
export default class MenuItemCard extends React.Component {
    constructor(props) {
        super(props);
        this.sendComboUrlData = this.sendComboUrlData.bind(this);
        this.state = { allComboData: null, loading: false }
        this.handleEnterKeyPress = this.handleEnterKeyPress.bind(this);
    }
    componentDidMount(){  
    }
        sendComboUrlData(e){
           // this.props.sendIsComboPage()
    }
    handleEnterKeyPress() {
        if (event.keyCode == 13) {
            $('.ihop-subcategory-card a')[0].click();
        }
    }
    render() {

        return (
            <div className="ihop-subcategory-card position-relative text-center" onKeyDown={this.handleEnterKeyPress} tabIndex="0">
              <a href={this.props.menuItemUrl} onClick ={this.sendComboUrlData}  tabindex="-1">
                <div className="subcategory-box">
                  <img src={this.props.menuItemImage} alt="product image" class="img-fluid" />

                  <div className="subcategory-description">
                            <h2>{this.props.menuItemTitle}</h2>
                            {
                                (typeof this.props.menuItemLabels !== 'undefined') ? (
                                    this.props.menuItemLabels.filter(labels => (labels.Code.toLowerCase() == "nychighsodium" || labels.Code.toLowerCase() == "phlsodiumwarning")).map(filteredLabel => (
                                        <img src={(filteredLabel.Code.toLowerCase() == "nychighsodium" ? "/-/media/ihop/images/icons/nyc_sodium-warning.png" :
                                            "/-/media/ihop/images/icons/phl_sodium-warning.png")} alt="warning image" data-code={filteredLabel.Code.toLowerCase()} className={"sub-c-" + filteredLabel.Code.toLowerCase() + " warning-img img-fluid"} />
                                    ))
                                ) : null}
                            {(this.props.menuItemCalcPrice > 0 || this.props.menuItemCalories) && (
                                <h3>
                                    {this.props.menuItemCalcPrice > 0 && this.props.menuItemPrice}
                                    {this.props.menuItemCalcPrice > 0 && this.props.menuItemCalories && ' | '}
                                    {this.props.menuItemCalories && `${this.props.menuItemCalories} `}
                                    {this.props.menuItemCalories && (
                                        <abbr aria-label={this.props.caloriesText}>{this.props.calAbbr}</abbr>
                                    )}
                                </h3>
                            )}




                  </div>
                </div>
              </a>            
            </div>
        );
    }
}
